import request from '../utils/request'
//列表
export function arbitrationList(req_type,limit,page) {
    return request.post('/api/zhcai_case_list',{"req_type":req_type,"limit":limit,"page":page})
}
//搜索
export function caseSearch(doc_title,signers,lawyer_name,status,req_type,limit,page) {
    return request.post('/api/zhcai_case_list',{"doc_title":doc_title,"signers":signers,"lawyer_name":lawyer_name,"status":status,"req_type":req_type,"limit":limit,"page":page})
}
//发起立案
export function accreditation(sign_type,zhcai_type,doc_title,contract_sn,sign_time,qingqiu,liyou,signers) {
    let obj={
        "sign_type":sign_type,
        "zhcai_type":zhcai_type,
        "doc_title":doc_title,
        "contract_sn":contract_sn,
        "sign_time":sign_time,
        "qingqiu":qingqiu,
        "liyou":liyou,
        "signers":signers
    }
    return request.post('/api/add_zhcai_case',obj)
}
//下载模板
export function downloadFile() {
    return request.post('/api/zhcai_case_tem_url')
}

//批量提交
export function submitCase(case_ids) {
    return request.post('/api/zhcai_case_batch_save',{"case_ids":case_ids})
}
//留言
export function leaveMessage(case_id,content) {
    return request.post('/api/zhcai_say_msg_to_lawyer',{"case_id":case_id,"content":content})
}
//查看留言
export function checkMessage(case_id) {
    return request.post('/api/zhcai_scan_lawyer_msg',{"case_id":case_id})
}
//案件详情
export function detailCase(case_id) {
    return request.post('/api/zhcai_case_detail',{"case_id":case_id})
}
//下载所有证据
export function allEvidence(case_id) {
    return request.post('/api/zhcai_case_dd_all_zju',{"case_id":case_id})
}
//下载所有仲裁文书
export function allDocuments(case_id) {
    return request.post('/api/zhcai_case_dd_all_wenshu',{"case_id":case_id})
}
//查看进度
export function checkProgress(case_id) {
    return request.post('/api/zhcai_case_scan_progress',{"case_id":case_id})
}
//补充证据接口
export function supplementaryInterface(case_id) {
    return request.post('/api/zhcai_case_extra_evidetail',{"case_id":case_id})
}
//保存补充证据
export function evidencePreserve(case_id,evidence_data) {
    return request.post('/api/zhcai_case_save_extra_evi',{"case_id":case_id,"evidence_data":evidence_data})
}
//下载补充证据清单
export function downloadSupplement(case_id) {
    return request.post('/api/zhcai_case_dd_all_extrazju',{"case_id":case_id})
}
//保存被申请人仲裁答辩书
export function plea(case_id,dabianshu,qitazhengju) {
    return request.post('/api/save_bei_dabian_evidence',{"case_id":case_id,"dabianshu":dabianshu,"qitazhengju":qitazhengju})
}
//查看被申请人上传仲裁答辩书
export function respondent(case_id) {
    return request.post('/api/zhcai_bei_dabian_detail',{"case_id":case_id})
}
//下载被申请人证据
export function defendantEvidence(case_id) {
    return request.post('/api/zhcai_case_dd_dabian_zju',{"case_id":case_id})
}
//申请人证据详情
export function applicantCertificate() {
    return request.post('/api/com_id_evi_detail')
}
//申请人证据 保存
export function saveEvidence(zhizhao,zhengfanmian,qita) {
    return request.post('/api/save_com_id_evi',{zhizhao,zhengfanmian,qita})
}
//申请人证据 下载
export function downloadApplicantEvidence(case_id) {
    return request.post('/api/com_id_evi_download_all',{"case_id":case_id})
}
//下载申请人其他证据
export function otherEvidence(case_id) {
    return request.post('/api/qita_evi_download_all',{"case_id":case_id})
}
//下载代理人信息
export function agentEvidence(case_id) {
    return request.post('/api/daili_info_download_all',{"case_id":case_id})
}
//删除案件
export function cancelCase(case_id) {
    return request.post('/api/zhcai_case_delete',{"case_id":case_id})
}
//修改仲裁立案信息
export function editFilingInformation(case_id) {
    return request.post('/api/zhcai_case_edit_detail',{"case_id":case_id})
}
//保存修改后的立案信息
export function afterModification(case_id,sign_type,zhcai_type,doc_title,contract_sn,sign_time,signers) {
    let obj={
        "case_id":case_id,
        "sign_type":sign_type,
        "zhcai_type":zhcai_type,
        "doc_title":doc_title,
        "contract_sn":contract_sn,
        "sign_time":sign_time,
        "signers":signers
    }
    return request.post('/api/edit_zhcai_case',obj)
}
//查看保险材料和文件
export function insuranceMaterials(case_id) {
    return request.post('/api/zhcai_scan_baoxian_files',{"case_id":case_id})
}
//下载保险材料和文件
export function downloadMaterialsFile(case_id) {
    return request.post('/api/zhcai_zip_baoxian_files',{"case_id":case_id})
}
